// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 18) return "static/js/85a40fef40cbf89a0270.bundle.js";
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"26":"f0f5832e57545050acb3","265":"a010ed5cf91fc667b059","266":"10498cf2fe065b07d32e"}[chunkId] + ".chunk.js";
};